export const ASSET_DATASOURCE_IDS = ["pdc_portal"] as const;
